import React from 'react'

const GPTMovieSuggestion = () => {
  return (
    <div>GPTMovieSuggestion</div>
  )
}

export default GPTMovieSuggestion